import { $subscriber, interact } from "fire-wind-water";
// import setting from "@/sktempjson/template-pc.json";
import { isSetting } from "@/common/sbase.js";
import { $extras, $messageLoad } from "@/../stempcore/src/core/sextra.js";

import settingPC from "@/sktempjson/fileList/template-pc.json";
import settingWAP from "@/sktempjson/fileList/template-wap.json";

let mixin = {
  data() {
    return {
      extras: {},
      isSetting: isSetting
    };
  },
  methods: {
    initConfig(configId, tenantId) {
      if (this.isSetting) {
        if (process.env.NODE_ENV === "development") {
          const html = interact.isMobile ? settingWAP.html : settingPC.html;
          this.extras = $extras(html).extras;
        }
        return;
      }
      this.service
        .getTemplateConfig({
          tenantId,
          configId
        })
        .subscribe(res => {
          window.$sk && window.$sk.loading.hide();
          this.extras = $extras(res.content.info.html).extras;
          if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
            let themeColorClear = "";
            const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
            if (rgbaAttr.length >= 3) {
              let r, g, b;
              r = rgbaAttr[0];
              g = rgbaAttr[1];
              b = rgbaAttr[2];
              themeColorClear =
                "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
            }

            document.body.style.setProperty(
              "--themeColor",
              this.extras.themecolor.bgcolor
            );
            document.body.style.setProperty(
              "--themeColorClear",
              themeColorClear
            );
          }
        });
    }
  },
  created() {
    console.log("# subscribe 'sk-template-config'.");
    $subscriber.subscribe("sk-template-config", o => {
      console.log("# catch 'sk-template-config' ...");
      // console.log("# o.data: ", JSON.stringify(o.data));
      this.extras = $extras(o.data).extras;
      if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
        let themeColorClear = "";
        const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
        if (rgbaAttr.length >= 3) {
          let r, g, b;
          r = rgbaAttr[0];
          g = rgbaAttr[1];
          b = rgbaAttr[2];
          themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
        }

        document.body.style.setProperty(
          "--themeColor",
          this.extras.themecolor.bgcolor
        );
        document.body.style.setProperty("--themeColorClear", themeColorClear);
      }
    });
  },
  mounted() {
    console.log("# $messageLoad ...");
    $messageLoad(1);
  }
};

export default mixin;
